/**
 * @generated SignedSource<<5468ea29cf7fc6ec9d096f9b9f220e55>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type CommentTypeInput = {
  id?: string | null | undefined;
  model: string;
  model_id: string;
  text: string;
};
export type CreateCommentMutation$variables = {
  connections: ReadonlyArray<string>;
  input: CommentTypeInput;
};
export type CreateCommentMutation$data = {
  readonly createComment: {
    readonly cursor: string;
    readonly node: {
      readonly commentable_id: string | null | undefined;
      readonly commentable_type: string | null | undefined;
      readonly commentator: {
        readonly first_name: string | null | undefined;
        readonly id: string;
        readonly last_name: string | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly created_at: string | null | undefined;
      readonly id: string | null | undefined;
      readonly text: string | null | undefined;
      readonly updated_at: string | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type CreateCommentMutation = {
  response: CreateCommentMutation$data;
  variables: CreateCommentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "connections"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": (v2/*: any*/),
  "concreteType": "CommentEdge",
  "kind": "LinkedField",
  "name": "createComment",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Comment",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commentable_type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "commentable_id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "text",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "commentator",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "first_name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "last_name",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "created_at",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "updated_at",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateCommentMutation",
    "selections": [
      (v4/*: any*/)
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CreateCommentMutation",
    "selections": [
      (v4/*: any*/),
      {
        "alias": null,
        "args": (v2/*: any*/),
        "filters": null,
        "handle": "prependEdge",
        "key": "",
        "kind": "LinkedHandle",
        "name": "createComment",
        "handleArgs": [
          {
            "kind": "Variable",
            "name": "connections",
            "variableName": "connections"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "17e9e5e21a36ac49294733edd640727d",
    "id": null,
    "metadata": {},
    "name": "CreateCommentMutation",
    "operationKind": "mutation",
    "text": "mutation CreateCommentMutation(\n  $input: CommentTypeInput!\n) {\n  createComment(input: $input) {\n    cursor\n    node {\n      id\n      commentable_type\n      commentable_id\n      text\n      commentator {\n        id\n        name\n        first_name\n        last_name\n      }\n      created_at\n      updated_at\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "a07b89e2ca88a6c68f373507680a2372";

export default node;
